// third-party
// types
import axiosDomain from "../../utils/axios/axiosDomain";
import { dispatch } from "../index";
import student from "store/slices/student";
import { User } from "../../types/type/users-types";
import { changeLoadingOperationStatus, changeLoadingStatus } from "../slices/loading";

// ----------------------------------------------------------------------

export function getAllStudents() {
    return async () => {
        try {
            dispatch(changeLoadingStatus(true))
            const response = await axiosDomain.get('/students');
            if (response.data.status == 'OK') {
                dispatch(student.actions.getAllStudents(response.data.result));
            } else {
                dispatch(student.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingStatus(false))
        } catch (error) {
            dispatch(student.actions.hasError(error));
            dispatch(changeLoadingStatus(false))
        }
    };
}

export function getSingleStudent(studentId: String | undefined) {
    return async () => {
        try {
            dispatch(changeLoadingStatus(true))
            const response = await axiosDomain.get('/students/' + studentId);
            if (response.data.status == 'OK') {
                Object.assign(response.data.result[0], {
                    tutors: response.data.tutors,
                })
                dispatch(student.actions.getSingleStudent(response.data.result[0]));
            } else {
                dispatch(student.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingStatus(false))
        } catch (error) {
            dispatch(student.actions.hasError(error));
            dispatch(changeLoadingStatus(false))
        }
    };
}

export function getActivitiesStudent(studentId: String | undefined) {
    return async () => {
        try {
            dispatch(changeLoadingStatus(true))
            const response = await axiosDomain.get('/activities/' + studentId);
            if (response.data.status === 'OK') {
                dispatch(student.actions.getActivitiesStudent(response.data.result));
            } else {
                dispatch(student.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingStatus(false))
        } catch (error) {
            dispatch(student.actions.hasError(error));
            dispatch(changeLoadingStatus(false))
        }
    };
}

export function addStudent(studentBody: User) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.post('/students/add', studentBody);
            if (response.data.status == 'OK') {
                dispatch(student.actions.insertNewStudent(response.data.result));
            } else {
                dispatch(student.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(student.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function updateStudent(studentId: String | undefined, studentBody: User) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.put('/students/' + studentId, studentBody);
            if (response.data.status == 'OK') {
                dispatch(student.actions.updateStudent(response.data.result));
                await dispatch(getSingleStudent(response.data.result.id))
            } else {
                dispatch(student.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(student.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}

export function deleteStudent(studentId: String | undefined) {
    return async () => {
        try {
            dispatch(changeLoadingOperationStatus(true))
            const response = await axiosDomain.delete('/students/' + studentId);
            if (response.data.status == 'OK') {
                dispatch(student.actions.deleteStudent(studentId));
            } else {
                dispatch(student.actions.hasError(response.data.message))
            }
            dispatch(changeLoadingOperationStatus(false))
        } catch (error) {
            dispatch(student.actions.hasError(error));
            dispatch(changeLoadingOperationStatus(false))
        }
    };
}